import { gql } from "@apollo/client";

export default gql`
  query getRaceWagers(
    $accountId: Int!
    $trackCode: String
    $raceNumber: Int
    $startDate: String
    $endDate: String
  ) {
    wagerHistory(
      accountId: $accountId
      trackCode: $trackCode
      raceNumber: $raceNumber
      beginDate: $startDate
      endDate: $endDate
    ) {
      id
      wagers {
        id
        serialNumber
        wagerAmount
        betTotal: cost
        winningsAmount: winnings
        betStatus {
          code
          name
        }
        wagerType {
          id
          code
          name
        }
        selections {
          selectionString
          modifier
          selection {
            bettingInterests {
              currentOdds {
                numerator
                denominator
              }
              biNumber
              isWinner
              runners {
                runnerId
                scratched
                horseName
              }
              payouts {
                amount
                wagerType {
                  code
                }
              }
            }
            selectionType {
              code
              name
            }
            runners {
              number
            }
          }
        }
        raceTypeAbbreviation: raceType
      }
    }
  }
`;
